/**
 * @file コンポーネント：価格 DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import {
    StyledPrice,
    StyledPriceNumber,
    StyledPricePurchased,
    StyledPriceTax,
    StyledPriceUnit,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledPrice>
            {props.isPurchased ? (
                // 購入済み
                <StyledPricePurchased>
                    {localized["Label.Purchased"]}
                </StyledPricePurchased>
            ) : (
                // 未購入
                <>
                    {props.unitPosition === "right" ? (
                        // 価格単位が右の場合
                        <>
                            <StyledPriceNumber>{props.price}</StyledPriceNumber>
                            <StyledPriceUnit
                                dangerouslySetInnerHTML={{ __html: props.unit }}
                            />
                            <StyledPriceTax>{props.tax}</StyledPriceTax>
                        </>
                    ) : (
                        // 価格単位が左の場合
                        <>
                            <StyledPriceUnit
                                dangerouslySetInnerHTML={{ __html: props.unit }}
                            />
                            <StyledPriceNumber>{props.price}</StyledPriceNumber>
                            <StyledPriceTax>{props.tax}</StyledPriceTax>
                        </>
                    )}
                </>
            )}
        </StyledPrice>
    );
};
